import { emptyArray } from 'ui-components/default-props/empty';

export const selectData = (state) => state ?? emptyArray;
